
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    cta: {
      type: Boolean,
      default: true
    }
  }
}
